import CLIENT from "../../lib/api/client";
import ENDPOINTS from "../../lib/api/endpoints";

export const quoteOrder = async (payload) => {
  const { data } = await CLIENT.post(ENDPOINTS.ORDERS.info, payload);

  return data;
};

export const reserveOrder = async (payload) => {
  const { data } = await CLIENT.post(ENDPOINTS.ORDERS.reserve, payload);

  return data;
};

export const placeOrder = async (payload) => {
  const { data } = await CLIENT.post(ENDPOINTS.ORDERS.root, payload);

  return data;
};

export const reserveMasterOrder = async (payload) => {
  const { data } = await CLIENT.post(ENDPOINTS.ORDERS.masterReserve, payload);

  return data;
};

export const placeMasterOrder = async (payload) => {
  const { data } = await CLIENT.post(ENDPOINTS.ORDERS.master, payload);

  return data;
};
